import React from "react";
import { FaUserCircle, FaPowerOff } from "react-icons/fa";

const Header = ({ user, logout }) => {
  return (
    <div className="flex justify-between items-center bg-white p-4 shadow-md sticky top-0 z-10">
      <div className="text-lg font-bold">Dashboard</div>
      <div className="flex items-center w-[27%] justify-evenly">
        <span className="mr-4">{user?.payload?.name}</span>
        <FaUserCircle className="text-xl" />
        <button onClick={logout}>
          <FaPowerOff className="text-red-500" />
        </button>
      </div>
    </div>
  );
};

export default Header;
